import { NewsArticlePreviewFields } from 'modules/NewsModule/NewsModule.previewQuery';

export const NewsArticleBlockFields = `
{
    title
    articles ${NewsArticlePreviewFields}
}
`;
